// yadsCancelScheduleReducer.js
import {
  DELETE_YADS_SCHEDULE_REQUEST,
  DELETE_YADS_SCHEDULE_SUCCESS,
  DELETE_YADS_SCHEDULE_FAILURE,
  DELETE_YADS_SCHEDULE_RESET,
} from '../../../Constants/actionTypes';

const initial = {
  loading: false,
  result: null,
  error: '',
};

const yadsCancelScheduleReducer = (state = initial, action) => {
  switch (action.type) {
    case DELETE_YADS_SCHEDULE_REQUEST:
      return { ...state, loading: true, error: '' };
    case DELETE_YADS_SCHEDULE_SUCCESS:
      return { loading: false, result: action.payload, error: '' };
    case DELETE_YADS_SCHEDULE_FAILURE:
      return { loading: false, result: null, error: action.payload };
    case DELETE_YADS_SCHEDULE_RESET:
      return initial;
    default:
      return state;
  }
};

export default yadsCancelScheduleReducer;
